import {
  clickLPFooterCompanyDetailsLink,
  clickLPFooterMembersRulesLink,
  clickLPFooterPrivacyLink,
  clickLPFooterRulesLink,
} from '@/utils/analytics/log-event';

type FooterLink = {
  display: string;
  url: string;
  logClickEvent: () => void;
};

type Props = {
  footerLink: FooterLink;
};

const FooterLink: React.FC<Props> = ({ footerLink }) => {
  return (
    <a
      href={footerLink.url}
      target="_blank"
      className="pl-4 first:pl-0"
      onClick={footerLink.logClickEvent}
    >
      {footerLink.display}
    </a>
  );
};

const Component: React.FC = () => {
  const footerLinks: FooterLink[] = [
    {
      display: '特定商取引法に基づく表示',
      url: 'https://my.shands.jp/tokusyo',
      logClickEvent: clickLPFooterCompanyDetailsLink,
    },
    {
      display: 'プライバシーポリシー',
      url: 'https://my.shands.jp/privacy',
      logClickEvent: clickLPFooterPrivacyLink,
    },
    {
      display: '会員規約',
      url: 'https://my.shands.jp/member_rules',
      logClickEvent: clickLPFooterMembersRulesLink,
    },
    {
      display: '利用規約',
      url: 'https://my.shands.jp/rules',
      logClickEvent: clickLPFooterRulesLink,
    },
  ];
  return (
    <div className="flex w-full justify-center border-t-[3px] border-solid border-orange-600 bg-[#d3d3d3] pb-10 pt-8 md:pb-12 md:pt-6">
      <div className="mx-8 flex w-full max-w-[920px] flex-col items-center justify-between gap-y-6 md:mx-0 md:flex-row md:gap-0">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 divide-x divide-gray-400 text-xs">
          {footerLinks.map(footerLink => (
            <FooterLink key={footerLink.display} footerLink={footerLink} />
          ))}
        </div>
        <div className="text-[10px]">
          Copyright &copy; Shakehands Inc. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};

export default Component;
